<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="服务网点" prop="nursinghomeName">
              <el-input
                clearable
                disabled
                v-model="form.nursinghomeName"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备编号" prop="name">
              <el-input
                clearable
                disabled
                v-model="form.code"
                placeholder="设备编号"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备名称" prop="name">
              <el-input
                clearable
                disabled
                v-model="form.name"
                placeholder="设备名称"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备IMEI号" prop="deviceSerial">
              <el-input
                clearable
                disabled
                v-model="form.deviceSerial"
                placeholder="设备IMEI号"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属设备大类" prop="deviceCategoryName">
              <el-input
                clearable
                disabled
                v-model="form.deviceCategoryName"
                placeholder="所属设备大类"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="设备类型" prop="deviceTypeName">
              <el-input clearable disabled v-model="form.deviceTypeName" maxlength="100"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="设备型号" prop="deviceModelName">
              <el-input
                clearable
                disabled
                v-model="form.deviceModelName"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="设备厂家" prop="vendor">
              <el-input
                clearable
                disabled
                v-model="form.vendor"
                placeholder="设备厂家"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="出厂时间" prop="leaveFactoryTime">
              <el-date-picker
                disabled
                v-model="form.leaveFactoryTime"
                style="width: 100%;"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择出厂时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="购入时间" prop="buyingTime">
              <el-date-picker
                disabled
                v-model="form.buyingTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
                placeholder="请选择购入时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="厂家保修期" prop="guaranteeEndTime">
              <el-date-picker
                disabled
                v-model="form.guaranteeEndTime"
                type="date"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                placeholder="请选择厂家保修期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属应用场景" prop="applicationScene">
              <el-select
                disabled
                v-model="form.applicationScene"
                style="width: 100%"
                placeholder="请选择所属应用场景"
              >
              <el-option
                  v-for="item in senceList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="安装位置" prop="installAddr">
              <el-input
                disabled
                maxlength="200"
                type="text"
                placeholder="请输入安装位置"
                v-model="form.installAddr"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input
                disabled
                type="textarea"
                :rows="2"
                placeholder="请输入备注"
                v-model="form.description"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.deviceTypeName == '智能摄像头'">
            <el-form-item label="平台视频地址" prop="cameraUrl">
              <el-input
                disabled
                maxlength="500"
                type="text"
                placeholder="请输入平台视频地址"
                v-model="form.cameraUrl"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.deviceTypeName == '智能摄像头'">
            <el-form-item label="大屏视频地址" prop="largeScreenAddress">
              <el-input
                disabled
                maxlength="500"
                type="text"
                placeholder="请输入大屏视频地址"
                v-model="form.largeScreenAddress"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="设备图片" prop="attachList">
              <vUpload
                disabled
                :message="'提示：上传文件不大于12MB，数量最多3张'"
                :types="['jpg', 'png']"
                :max="12 * 1024 * 1024"
                :limit="3"
                :fileList.sync="form.attachList"
              ></vUpload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import { getSmartDeviceResumeBasicInfo } from '@/api/nursingHome/artificalDevice';
import vUpload from '../../components/mutil-upload.vue';
export default {
  components: { vUpload },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [],
      deviceCategoryList: [],
      form: {
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode: '',
        applicationScene: '',
        installAddr: '',
      },
      formRules: {},
      matetialList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
      senceList: [],
    };
  },
  created() {
  },
  mounted() {
    this.initData();
  },
  watch: {},
  methods: {
    initData() {
      getDictionary('application_scene').then((res) => {
        this.senceList = res.data;
      });
      getSmartDeviceResumeBasicInfo({ id: this.row.id }).then((res) => {
        this.form = res.data;
      });
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
